export default __webpack_public_path__ + "static/media/banner5.3c057340.png";